import Agent from "@/store/modules/agent";
import Automation from "@/store/modules/automation";
import Backup from "@/store/modules/backup";
import Business from "@/store/modules/business";
import CampaignBudget from "@/store/modules/campaign-budget";
import CashRegister from "@/store/modules/cash-register";
import Attribute from "@/store/modules/catalog/attribute";
import Category from "@/store/modules/catalog/category";
import Collection from "@/store/modules/catalog/collection";
import Products from "@/store/modules/catalog/product";
import Assistant from "@/store/modules/channel/assistant";
import Whatsapp from "@/store/modules/channel/whatsapp";
import Coach from "@/store/modules/coach";
import Contact from "@/store/modules/contact";
import Device from "@/store/modules/device";
import Event from "@/store/modules/event";
import Calendar from "@/store/modules/calendar";
import File from "@/store/modules/file";
import FormSchema from "@/store/modules/form-schema";
import Help from "@/store/modules/help";
import ImporterSchema from "@/store/modules/importer-schema";
import Integration from "@/store/modules/integration";
import Loyalty from "@/store/modules/loyalty";
import Notification from "@/store/modules/notification";
import Order from "@/store/modules/order";
import Origin from "@/store/modules/origin";
import OriginCategory from "@/store/modules/origin-category";
import PaymentMethod from "@/store/modules/payment-method";
import Project from "@/store/modules/project";
import Quota from "@/store/modules/quota";
import Segment from "@/store/modules/segment";
import State from "@/store/modules/state";
import Store from "@/store/modules/store";
import Subscription from "@/store/modules/subscription";
import Tag from "@/store/modules/tag";
import Team from "@/store/modules/team";
import Ticket from "@/store/modules/ticket";
import Timeline from "@/store/modules/timeline";
import Warehouse from "@/store/modules/warehouse";
import Webhook from "@/store/modules/webhook";
import Zone from "@/store/modules/zone";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Agent,
    Contact,
    Timeline,
    Order,
    Products,
    Event,
    Calendar,
    Ticket,
    Tag,
    State,
    Device,
    Project,
    Team,
    Webhook,
    Integration,
    CampaignBudget,
    Segment,
    Origin,
    OriginCategory,
    Business,
    Category,
    Collection,
    Attribute,
    Store,
    Zone,
    PaymentMethod,
    Help,
    Subscription,
    Quota,
    Automation,
    Loyalty,
    ImporterSchema,
    FormSchema,
    CashRegister,
    Warehouse,
    Backup,
    Whatsapp,
    Assistant,
    Coach,
    File,
    Notification,
  },
});
